import { extendTheme } from '@chakra-ui/react';
export const mainTheme = extendTheme({
  colors: {
    brand: {
      50: '#f2e6ff',
      100: '#cdb4f7',
      200: '#b48ff3',
      300: '#9b69ef',
      400: '#7f26f2',
      500: '#8244eb',
      600: '#6836bc',
      700: '#4e298d',
      800: '#341b5e',
    },
    secondary: {
      50: '#d8fffe',
      100: '#abf4ff',
      200: '#99e1ff',
      300: '#66d1ff',
      400: '#33c2ff',
      500: '#00B3FF',
      600: '#008fff',
      700: '#006b99',
      800: '#004866',
    },
    accentPink: {
      50: '#ffe5fa',
      100: '#fcb7e5',
      200: '#F9BDE1',
      300: '#F79DD3',
      400: '#F47CC4',
      500: '#F15BB5',
      600: '#C14991',
      700: '#91376D',
      800: '#602448',
      900: '#1c001c',
    },
    accentGreen: {
      50: '#eaffdf',
      100: '#DBFFCF',
      200: '#c6ffb1',
      300: '#C8FFB7',
      400: '#B6FF9F',
      500: '#A4FF87',
      600: '#83CC6C',
      700: '#629951',
      800: '#426636',
      900: '#0d1b00',
    },
    accentRed: {
      50: '#ffebee',
      100: '#ffcdd2',
      200: '#ef9a9a',
      300: '#e57373',
      400: '#ef5350',
      500: '#f44336',
      600: '#e53935',
      700: '#d32f2f',
      800: '#c62828',
      900: '#b71c1c',
    },
  },
  fonts: {
    body: 'Mueller',
    // heading: 'Mueller',
  },
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg: 'white',
        color: '#203b54',
        fontWeight: '300',
        // overflowX: 'hidden',
      },
      // force all the modals to have a margin x of 12px on mobile
      '.chakra-modal__content': {
        mx: { base: '12px', md: 'auto' },
      },
      // force all the modal body to have overflow-x hidden
      '.chakra-modal__body': {
        overflowX: 'hidden !important',
      },

      // styles for the `a`
      // a: {
      //   _hover: {
      //     textDecoration: 'underline',
      //   },
      // },
    },
  },
});
